export default {
  dashboardLoginLogs: '/dashboard/login-logs',
};
